"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUser = exports.getGardens = void 0;
const connect_thegraph_1 = require("@aragon/connect-thegraph");
const connector_1 = require("./thegraph/connector");
const queries_1 = require("./thegraph/queries");
async function getGardens(config, { first = 1000, skip = 0, orderBy = 'createdAt', orderDirection = 'desc' }) {
    const client = getSubgraphClient(config);
    const result = await client.performQuery(queries_1.ORGANIZATIONS, { first, skip, orderBy, orderDirection });
    if (!result.data.organizations) {
        throw new Error('Unable to find gardens.');
    }
    return result.data.organizations;
}
exports.getGardens = getGardens;
async function getUser(config, { id }) {
    const client = getSubgraphClient(config);
    const result = await client.performQuery(queries_1.USER, { id });
    if (!result.data.user) {
        throw new Error('Unable to find user.');
    }
    return result.data.user;
}
exports.getUser = getUser;
function getSubgraphClient(config) {
    var _a, _b;
    const subgraphUrl = (_b = (_a = config === null || config === void 0 ? void 0 : config.subgraphUrl) !== null && _a !== void 0 ? _a : connector_1.subgraphUrlFromChainId(config.network)) !== null && _b !== void 0 ? _b : undefined;
    if (!subgraphUrl) {
        throw new Error('subgraphUrl required to be passed.');
    }
    return new connect_thegraph_1.GraphQLWrapper(subgraphUrl);
}
//# sourceMappingURL=gardens.js.map